import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

export default function ApplicantsAdmin() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedResume, setSelectedResume] = useState(null); // 🔹 for modal

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const q = query(
          collection(db, "jobApplications"),
          orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setApplications(data);
      } catch (error) {
        console.error("Error fetching applications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  if (loading) {
    return <div className="p-10 text-center">Loading applications...</div>;
  }

  return (
    <div className="min-h-screen bg-[var(--bg-1)] p-6 md:p-10">
      <h1 className="text-3xl font-serif text-[var(--brand-dark)] mb-6">
        Job Applications
      </h1>

      {applications.length === 0 ? (
        <p className="text-gray-500">No applications yet</p>
      ) : (
        <div className="overflow-x-auto bg-white rounded-xl shadow-md border">
          <table className="w-full text-sm">
            <thead className="bg-[var(--bg-3)]">
              <tr>
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Email</th>
                <th className="p-3 text-left">Phone</th>
                <th className="p-3 text-left">Job</th>
                <th className="p-3 text-left">Resume</th>
                <th className="p-3 text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app) => (
                <tr key={app.id} className="border-t hover:bg-[var(--bg-2)]">
                  <td className="p-3">{app.name}</td>
                  <td className="p-3">{app.email}</td>
                  <td className="p-3">{app.phone}</td>
                  <td className="p-3">{app.jobTitle}</td>

                  {/* RESUME ACTIONS */}
                  <td className="p-3">
                    <div className="flex gap-4">
                      <a
                        href={app.resumeURL}
                        download
                        className="text-blue-600 font-medium hover:underline"
                      >
                        Download
                      </a>
                    </div>
                  </td>

                  <td className="p-3">
                    {app.createdAt?.toDate
                      ? app.createdAt.toDate().toLocaleDateString()
                      : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ================= MODAL PREVIEW ================= */}
      {selectedResume && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-[90%] md:w-[70%] h-[80%] rounded-lg shadow-lg relative">
            {/* Close Button */}
            <button
              onClick={() => setSelectedResume(null)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>

            {/* Resume Preview */}
            <iframe
              src={selectedResume}
              title="Resume Preview"
              className="w-full h-full rounded-b-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
}
